import { LoadingButton } from '@mui/lab';
import { Grid } from '@mui/material';
import Navbar from 'components/Navbar';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { gql, useLazyQuery } from '@apollo/client';
import { downloadBinaryData } from 'utils/admin';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

const DOWNLOAD_USER_PERFORMANCE_QUERY = gql`
  query DownloadUserPerformance($year: Int) {
    downloadUserPerformance(year: $year) {
      file
      fileName
    }
  }
`;

type DownloadUserPerformanceResponse = {
  downloadUserPerformance: {
    file: string;
    fileName: string;
  };
};

type DownloadUserPerformanceVariables = {
  year: number;
};

const DOWNLOAD_OBJECTIVE_SETTINGS_QUERY = gql`
  query DownloadObjectiveSettings($year: Int) {
    downloadObjectiveSettings(year: $year) {
      file
      fileName
    }
  }
`;

type DownloadObjectiveSettingsResponse = {
  downloadObjectiveSettings: {
    file: string;
    fileName: string;
  };
};
type DownloadObjectiveSettingsVariables = {
  year: number;
};

const DOWNLOAD_MID_YEAR_REVIEWS = gql`
  query DownloadMidYearReviews($year: Int) {
    downloadMidYearReviews(year: $year) {
      file
      fileName
    }
  }
`;

type DownloadMidYearReviewsResponse = {
  downloadMidYearReviews: {
    file: string;
    fileName: string;
  };
};
type DownloadMidYearReviewsVariables = {
  year: number;
};

const DOWNLOAD_END_YEAR_REVIEWS = gql`
  query DownloadEndYearReviews($year: Int) {
    downloadEndYearReviews(year: $year) {
      file
      fileName
    }
  }
`;
export type DownloadEndYearReviewsResponse = {
  downloadEndYearReviews: {
    file: string;
    fileName: string;
  };
};
type DownloadEndYearReviewsVariables = {
  year: number;
};
const AdminReportsPage = () => {
  const [downloadUserPerformance, { loading: downloadingUserPerformance }] = useLazyQuery<
    DownloadUserPerformanceResponse,
    DownloadUserPerformanceVariables
  >(DOWNLOAD_USER_PERFORMANCE_QUERY);

  const [downloadObjectivesettings, { loading: downloadingObjectiveSettings }] = useLazyQuery<
    DownloadObjectiveSettingsResponse,
    DownloadObjectiveSettingsVariables
  >(DOWNLOAD_OBJECTIVE_SETTINGS_QUERY);

  const [downloadMidYearReviews, { loading: downloadingMidYearReviews }] = useLazyQuery<
    DownloadMidYearReviewsResponse,
    DownloadMidYearReviewsVariables
  >(DOWNLOAD_MID_YEAR_REVIEWS);

  const [downloadEndYearReviews, { loading: downloadingEndYearReviews }] = useLazyQuery<
    DownloadEndYearReviewsResponse,
    DownloadEndYearReviewsVariables
  >(DOWNLOAD_END_YEAR_REVIEWS);

  const handleDownloadReport = () => {
    downloadUserPerformance({
      variables: {
        year: getSelectedObjectiveGoalsYear(),
      },
      onCompleted: res => {
        downloadBinaryData({
          filename: res.downloadUserPerformance.fileName,
          content: res.downloadUserPerformance.file,
        });
      },
    });
  };

  const handleDownloadObjectiveSettings = () => {
    downloadObjectivesettings({
      variables: {
        year: getSelectedObjectiveGoalsYear(),
      },
      onCompleted: res => {
        downloadBinaryData({
          filename: res.downloadObjectiveSettings.fileName,
          content: res.downloadObjectiveSettings.file,
        });
      },
    });
  };

  const handleDownloadMidReviews = () => {
    downloadMidYearReviews({
      variables: {
        year: getSelectedObjectiveGoalsYear(),
      },
      onCompleted: res => {
        downloadBinaryData({
          filename: res.downloadMidYearReviews.fileName,
          content: res.downloadMidYearReviews.file,
        });
      },
    });
  };

  const handleDownloadEndReviews = () => {
    downloadEndYearReviews({
      variables: {
        year: getSelectedObjectiveGoalsYear(),
      },
      onCompleted: res => {
        downloadBinaryData({
          filename: res.downloadEndYearReviews.fileName,
          content: res.downloadEndYearReviews.file,
        });
      },
    });
  };

  return (
    <Navbar title={`Admin Reports - ${getSelectedObjectiveGoalsYear()}`}>
      <Grid
        display={'block'}
        container
        justifyContent="flex-start"
        flexDirection="column"
        px={1}
        mt={5}
        alignItems="flex-start"
        rowSpacing={3}
        xs={12}
        md={6}
      >
        <Grid item xs={12} md={6}>
          <LoadingButton
            fullWidth
            startIcon={<FileDownloadIcon />}
            onClick={handleDownloadReport}
            loading={downloadingUserPerformance}
            variant="contained"
          >
            Organization Report Status
          </LoadingButton>
        </Grid>
        <Grid item xs={12} md={6}>
          <LoadingButton
            fullWidth
            startIcon={<FileDownloadIcon />}
            onClick={handleDownloadObjectiveSettings}
            loading={downloadingObjectiveSettings}
            variant="contained"
          >
            Objective Settings
          </LoadingButton>
        </Grid>
        <Grid item xs={12} md={6}>
          <LoadingButton
            fullWidth
            startIcon={<FileDownloadIcon />}
            onClick={handleDownloadMidReviews}
            loading={downloadingMidYearReviews}
            variant="contained"
          >
            Mid Year Reviews
          </LoadingButton>
        </Grid>
        <Grid item xs={12} md={6}>
          <LoadingButton
            fullWidth
            startIcon={<FileDownloadIcon />}
            loading={downloadingEndYearReviews}
            onClick={handleDownloadEndReviews}
            variant="contained"
          >
            End Year Reviews
          </LoadingButton>
        </Grid>
      </Grid>
    </Navbar>
  );
};

export default AdminReportsPage;
